import { GridColDef } from "@mui/x-data-grid";
import { Box, Chip, Typography } from "@mui/material";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Inventory } from "@mui/icons-material";
import { PARTS_ENDPOINT } from "../../../consts";
import { useNavigate } from "react-router-dom";
import { useHasPermission } from "../../../contexts/auth";
import { formatQuantity } from "../../../utils";
import {
  containsStringFilterOperators,
  equalsNumberFilterOperators,
  equalsStringFilterOperators,
} from "../../../components/ui/customDataGrid/filterOperators";

export default function StockStatusList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewParts = useHasPermission("service.view_part");

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      filterOperators: equalsNumberFilterOperators(),
    },
    {
      field: "name",
      headerName: t("Name"),
      filterOperators: containsStringFilterOperators(),
    },
    {
      field: "code",
      headerName: t("Code"),
      filterOperators: containsStringFilterOperators(),
    },
    {
      field: "unit",
      headerName: t("Unit"),
      filterOperators: equalsStringFilterOperators(),
    },
    {
      field: "stock_quantity",
      headerName: t("Stock Quantity"),
      type: "number",
      filterOperators: equalsNumberFilterOperators(),
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: params.row.is_below_notification_threshold ? 700 : 400 }}
            color={params.row.is_below_notification_threshold ? "error.main" : undefined}
          >
            {`${formatQuantity(params.value)} ${params.row.unit ?? ""}`.trim()}
          </Typography>
          {params.row.is_below_notification_threshold && (
            <Chip size="small" color="error" variant="outlined" label={t("Low stock")} />
          )}
        </Box>
      ),
    },
    {
      field: "notification_threshold",
      headerName: t("Notification Threshold"),
      type: "number",
      filterOperators: equalsNumberFilterOperators(),
      valueFormatter: (value) => formatQuantity(value),
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/service/stock-status/${id}`);
  };

  if (!canViewParts) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<Inventory />}
      title={t("Stock Status")}
      url={PARTS_ENDPOINT}
      gridSettingsKey="STOCK_STATUS"
      columns={columns}
      refreshEventName={["partAdded", "partUpdated"]}
      onRowClick={handleRowClick}
    />
  );
}
